import { createActions, handleActions } from "redux-actions";

const defaultState = {
  loading: false,
};

export const { beginCrm, getCrmData, saveCrmData, errorCrm } = createActions(
  "BEGIN_CRM",
  "GET_CRM_DATA",
  "SAVE_CRM_DATA",
  "ERROR_CRM"
);

export default handleActions(
  {
    [beginCrm]: (state, { data = {} }) => {
      return { ...defaultState, loading: true };
    },
    [getCrmData]: (state, { payload = {} }) => {
      // console.log(payload);
      return { ...state, ...payload, loading: false };
    },
    [saveCrmData]: (state, { payload = {} }) => {
      // console.log(payload);
      return { ...state, ...payload, loading: false };
    },
    [errorCrm]: (state, { payload = {} }) => {
      // console.log(payload);
      return { ...state, authError: payload };
    },
  },
  defaultState
);
